<template>
  <div :class="classObj" class="layout">
    <SideBar />

    <div class="main-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import SideBar from './sidebar/SideBar';
import SidebarComputed from '@/assets/mixins/SidebarComputed';

  export default {
    name: 'RouterPageView',

    mixins : [SidebarComputed],

    components: {
      SideBar
    },

    methods: {
      handleClickOutside() {
        this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/RouterPageView.vue